import './App.css';
import { Route, Switch, Redirect } from 'react-router-dom';
import SignIn from './components/auth/sign-in/sign-in'
import SignUp from './components/auth/sign-up/sign-up'
import ResetPwd from './components/auth/reset-pwd/reset-pwd'
import Home from './components/home/home'
import About from './components/about/about'
import React from'react'
import UploadSurvey from "./components/upload-survey/upload-survey";
import UploadSuccess from "./components/upload-survey/upload-successful";
import { Auth } from './index';
import { useHistory } from 'react-router-dom';
const App = () => {

  const [signedIn, setSignedIn] = React.useState(sessionStorage.getItem("signedIn"));
  const history = useHistory()

  const handleLogOut = () => {
    Auth.signOut();
    setSignedIn(false);
    sessionStorage.removeItem("signedIn");
    history.push("/home");
  }

  return (
    <Switch>
      <Route exact path='/' render={() => <Home signedIn={signedIn} handleLogOut={handleLogOut}/>}/>
      <Route path='/sign-up' render={() => <SignUp setSignedIn={setSignedIn}/>}/>
      <Route path='/sign-in' render={() => <SignIn setSignedIn={setSignedIn}/>}/>
      <Route path='/reset-password' render={() => <ResetPwd/>}/>
      <Route path='/about' render={()=> <About signedIn={signedIn} handleLogOut={handleLogOut}/>}/>
      <Route path='/upload' render={() => <UploadSurvey/>}/>
      <Route path='/upload-successful' render={() => <UploadSuccess/>}/>
      <Redirect to='/'/>
    </Switch>
  );
}

export default App;
